import React from "react";

/**
 * Centered loading state with an animated SVG ring spinner.
 *
 * Renders flex-1 so it fills its parent (e.g. inside a <Tile>) and the
 * spinner is centered in the available frame instead of clinging to the
 * top-left corner.
 */
export function Loading({ label }: { label?: string }) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-sm text-textLight text-sm py-lg min-h-[120px]">
      <Spinner />
      {label && <span>{label}</span>}
    </div>
  );
}

export function Spinner({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      className="animate-spin text-brand"
      aria-hidden="true"
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="currentColor"
        strokeOpacity="0.18"
        strokeWidth="5"
      />
      <path
        d="M25 5 a20 20 0 0 1 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
      />
    </svg>
  );
}
